import { Skull } from "lucide-react";

export function SkullRating({ value = 0, count, size = 14, interactive = false, onChange, testId = "skull-rating" }) {
  return (
    <div className="flex items-center gap-1" data-testid={testId}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          disabled={!interactive}
          onClick={() => interactive && onChange?.(n)}
          data-testid={interactive ? `${testId}-skull-${n}` : undefined}
          aria-label={`${n} skulls`}
          className={interactive ? "cursor-pointer transition-transform duration-100 hover:scale-125" : "cursor-default"}
        >
          <Skull size={size} className={n <= Math.round(value) ? "fill-crimson text-crimson" : "text-paper/25"} />
        </button>
      ))}
      {count != null && (
        <span className="font-courier text-[10px] text-paper/40 ml-1">
          {value ? value.toFixed(1) : "—"} ({count})
        </span>
      )}
    </div>
  );
}
